import WhetherSolve from '@/containers/qa-drawer/components/whether-solve';
import AnimationContainer from '@/components/animation-container';
import { ISolveStatus } from '@/types/models/qa';
import './index.scss';

interface ITeacherQaTipsCard {
    type: 'teacherQaTips';
    date: string;
}

// interface IWaitTeacherReply {
//     type: 'waitTeacherReply';
// }

interface IWhetherSolve {
    type: 'whetherSolve';
    title?: string;
    /**
     * 0 待解决 1 已解决 2 未解决
     */
    state: ISolveStatus;
}

export type ISystem = {
    role: 'system';
} & (ITeacherQaTipsCard | IWhetherSolve);

const System = (data: ISystem) => {
    switch (data.type) {
        case 'whetherSolve':
            return <WhetherSolve state={data.state} title={data.title} />;
        case 'teacherQaTips':
            return (
                <AnimationContainer type="fade_in">
                    <div className="teacher-qa-tips-date">{data.date}</div>
                    <div className="teacher-qa-tips">
                        <div className="teacher-qa-tips__title">名师答疑</div>
                        <div className="teacher-qa-tips__text">该问题已转至名师回复</div>
                    </div>
                </AnimationContainer>
            );
        default:
            return null;
    }
};

export default System;
